import { useId } from 'react';

/**
 * CrimsonArc Technologies wordmark icon: crimson trajectory arc, endpoints as connection nodes,
 * a light “signal” polyline, and a pointer cursor riding inside the arc (build / interact).
 */
export default function CrimsonArcLogoMark() {
  const raw = useId();
  const uid = raw.replace(/:/g, '');

  return (
    <svg
      className="ca-logo-mark"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={`${uid}-lg`} x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#7f1d1d" stopOpacity="0.55" />
          <stop offset="45%" stopColor="#dc2626" stopOpacity="1" />
          <stop offset="100%" stopColor="#fecaca" stopOpacity="0.85" />
        </linearGradient>
        <filter id={`${uid}-glow`} x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="1.2" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* subtle bracket / ground — platform base */}
      <path
        className="ca-logo-mark__base"
        d="M10 36h24"
        stroke="rgba(248,113,113,0.22)"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        className="ca-logo-mark__spark"
        pathLength={100}
        d="M 12 26 L 17 20 L 24 24 L 30 16 L 36 22"
        stroke="rgba(248,113,113,0.5)"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Pointer in the bowl under the arc; arc drawn after so the stroke reads above the interior */}
      <g className="ca-logo-mark__cursor">
        <g transform="translate(1.2 2.2) scale(0.8) translate(-1.2 -2.2)">
          <g transform="rotate(-24 1.2 2.2)">
            <path
              d="M 1.2 2.2 L 1.2 12.8 L 4.35 9.65 L 6.75 15.1 L 8.35 14 L 6.05 9.05 L 10.15 9.05 Z"
              fill="#f8fafc"
              stroke="#dc2626"
              strokeWidth="0.85"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <path
        className="ca-logo-mark__arc"
        pathLength={100}
        d="M 7 30 Q 22 5 37 30"
        stroke={`url(#${uid}-lg)`}
        strokeWidth="2.35"
        strokeLinecap="round"
        filter={`url(#${uid}-glow)`}
      />
      <circle className="ca-logo-mark__node ca-logo-mark__node--a" cx="7" cy="30" r="3.2" fill="#ef4444" />
      <circle className="ca-logo-mark__node ca-logo-mark__node--b" cx="37" cy="30" r="3.2" fill="#fecaca" />
    </svg>
  );
}
